import { defineEphemeralSlice } from "../runtime/defineEphemeralSlice";

/**
 * State of a programmatic bike-station popup request from the itinerary UI.
 */
export interface BikeStationPopupRequestState {
    "stationId": string;
    "operator":  string;
    "name":      string;
    "lat":       number;
    "lon":       number;
    "visible":   boolean;
}

/** Default/inactive bike station popup request. */
export const BIKE_STATION_POPUP_REQUEST_DEFAULT: BikeStationPopupRequestState = {
    "stationId": "",
    "operator":  "",
    "name":      "",
    "lat":       0,
    "lon":       0,
    "visible":   false,
};

/**
 * Ephemeral slice used by the itinerary panel to ask the map to open a
 * bike-station popup and zoom to the requested station.
 */
export const bikeStationPopupRequestSlice = defineEphemeralSlice<BikeStationPopupRequestState>( {
    "key":     "bikeStationPopupRequest",
    "default": () => BIKE_STATION_POPUP_REQUEST_DEFAULT,
} );
